import { render, staticRenderFns } from "./DeviceList.vue?vue&type=template&id=1ff54cb8&scoped=true"
import script from "./DeviceList.vue?vue&type=script&lang=js"
export * from "./DeviceList.vue?vue&type=script&lang=js"
import style0 from "./DeviceList.vue?vue&type=style&index=0&id=1ff54cb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff54cb8",
  null
  
)

export default component.exports